module.exports = __webpack_public_path__ + "img/activate-vpn-uc-browser.62af0842.webp";